var components
try {
  components = {
    zPaging: function () {
      return import(
        /* webpackChunkName: "uni_modules/z-paging/components/z-paging/z-paging" */ "@/uni_modules/z-paging/components/z-paging/z-paging.vue"
      )
    },
    uImage: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-image/u-image" */ "uview-ui/components/u-image/u-image.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uInput: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-input/u-input" */ "uview-ui/components/u-input/u-input.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-button/u-button" */ "uview-ui/components/u-button/u-button.vue"
      )
    },
    uToast: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-toast/u-toast" */ "uview-ui/components/u-toast/u-toast.vue"
      )
    },
    uModal: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-modal/u-modal" */ "uview-ui/components/u-modal/u-modal.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.detail ? _vm.vk.pubfn.isNotNull(_vm.detail.tumbup) : null
  var g1 = _vm.detail ? _vm.detail.tumbups.length : null
  var g2 = _vm.detail ? _vm.comments.length : null
  var g3 = _vm.detail ? _vm.comments.length : null
  var l0 = _vm.detail
    ? _vm.__map(_vm.comments, function (item, __i0__) {
        var $orig = _vm.__get_orig(item)
        var m0 = _vm.showDel(item)
        return {
          $orig: $orig,
          m0: m0,
        }
      })
    : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, item) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        item = _temp2.item
      var _temp, _temp2
      _vm.delFlag = true
      _vm.selectId = item._id
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }